<script setup lang="ts">
import Button from 'primevue/button';
import type { Component } from 'vue';
import { RouterLink } from 'vue-router';

defineProps<{ name: string; icon?: Component; index: number; url: string; class?: string }>();
</script>

<template>
  <RouterLink :to="url">
    <div :class="['flex w-full items-center gap-4', $props.class]">
      <div v-if="icon" class="h-6 w-6">
        <component :is="icon" class="text-primary-950" />
      </div>
      <div class="flex grow items-center justify-between border-b border-primary-500" :class="{ 'border-t': index === 0 }">
        <p class="py-3">{{ name }}</p>
        <Button rounded link icon="pi pi-chevron-right" class="text-xl" />
      </div>
    </div>
  </RouterLink>
</template>
